import { render, staticRenderFns } from "./ServiceRequestPage.vue?vue&type=template&id=511272fe"
import script from "./ServiceRequestPage.vue?vue&type=script&lang=js"
export * from "./ServiceRequestPage.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestPage.vue?vue&type=style&index=0&id=511272fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports